//FAW Data
export const UPDATE_WINE_TYPE = 'UPDATE_WINE_TYPE'
export const UPDATE_PRICE_RANGE = 'UPDATE_PRICE_RANGE'
export const UPDATE_VARIETAL = 'UPDATE_VARIETAL'
export const UPDATE_CURRENT_VIEW = 'UPDATE_CURRENT_VIEW'
export const UPDATE_SELECTED_TYPE = 'UPDATE_SELECTED_TYPE'
export const RESET_SELECTION = 'RESET_SELECTION'
export const UPDATE_STORE_DETAILS = 'UPDATE_STORE_DETAILS'
export const PDP_OPENED = 'PDP_OPENED'
export const SHOW_FAW = 'SHOW_FAW'

//Product Search
export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS'
export const RECEIVED_PRODUCTS = 'RECEIVED_PRODUCTS'
export const ERROR_RECEIVED = 'ERROR_RECEIVED'

//Bot Data
export const IS_WIDGET_OPEN_FIRST_TIME = 'IS_WIDGET_OPEN_FIRST_TIME'

//Live Chat Data
export const UPDATE_LC_USER_INITIAL_POSITION = 'UPDATE_LC_USER_INITIAL_POSITION'
export const UPDATE_LC_USER_POSITION = 'UPDATE_LC_USER_POSITION'
export const IS_LC_MESSAGE_TRIGGERED = 'IS_LC_MESSAGE_TRIGGERED'



